import { Component, HostListener, OnInit } from '@angular/core';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { FullscreenService } from 'src/app/shared/services/fullscreen.service';
import { Store } from '@ngrx/store';
import { CommonActions, CommonFeatureState, CommonSelectors } from 'src/app/store';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    showDialog = false;
    activeComponent;
    helpLinks$ = this.store.select(CommonSelectors.selectHelpLinks);

    fullscreen = false;

    public isMenuOpen = false;

    constructor(private dialogService: DialogService, private fullScreenService: FullscreenService, private store: Store<{ commonStore: CommonFeatureState }>) {
        this.fullScreenService.getFullScreenStatus().subscribe((data) => {
            this.fullscreen = data;
        });
    }

    ngOnInit(): void {
        this.store.dispatch(CommonActions.loadHelpLinks());

        this.dialogService.activeComponent().subscribe((activeComponent) => {
            if (!activeComponent) {
                this.closeDialog();
            }
            this.activeComponent = activeComponent;
        });
    }

    @HostListener('document:keydown', ['$event'])
    onKeyDownHandler(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.closeDialog();
        }
    }

    // listener for a[routerLink] click
    @HostListener('click', ['$event.target'])
    onClick(targetElement: HTMLElement) {
        const routerLink = targetElement.getAttribute('routerLink');
        if (routerLink) {
            this.isMenuOpen = false;
        }
    }

    closeDialog() {
        this.showDialog = false;
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }
}
